import { Spinner } from './Spinner';

export const PageLoader = () => {
  return (
    <div className="absolute left-1/2 top-1/3 flex -translate-x-1/2 items-center pt-40 md:pt-0">
      <Spinner size="large" />
    </div>
  );
};
